import {
  ADD_FUNDS_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  PAYMENTS_ROUTE,
  SETTINGS_ROUTE,
  TRANSFER_ROUTE,
  WITHDRAW_ROUTE,
} from "_constants";
import { lazy } from "react";

const Settings = lazy(() => import("pages/settings"));
const ChangePassword = lazy(() => import("pages/settings/change-password"));
const AddFunds = lazy(() => import("pages/settings/payments/add-funds"));
const Withdraw = lazy(() => import("pages/settings/payments/withdraw"));
const Payments = lazy(() => import("pages/settings/payments"));
const Transfer = lazy(() => import("pages/settings/payments/transfer"));

export const settingsRoutes = [
  { path: SETTINGS_ROUTE, element: <Settings /> },
  { path: CHANGE_PASSWORD_ROUTE, element: <ChangePassword /> },
  { path: PAYMENTS_ROUTE, element: <Payments /> },
  { path: ADD_FUNDS_ROUTE, element: <AddFunds /> },
  { path: WITHDRAW_ROUTE, element: <Withdraw /> },
  { path: TRANSFER_ROUTE, element: <Transfer /> },
];
